import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 20px 0;
  width: ${props => props.block ? "100%" : "auto"}
`;

export const InputElement = styled.textarea`
  width: 100%;
  display: block;
  padding: 10px 16px;
  border: ${props => props.hasError ? "solid 1px #7f1414" : "solid 1px #b3b3b3" };
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  margin-top: 5px;
  font-size: 16px;
  resize: vertical;
  min-height: 90px;
  @media (max-width: 468px){
    font-size: 14px;
  }
  &:focus {
    border: solid 1px #ecbc2b;
    box-shadow: none;
    outline: 0 !important;
    color: #2c2c2c;
    transition: all 0.30s ease-in-out;
  }
`;

const LabelElement = styled.label`
  font-size: 12px;
  color: ${props => props.hasError ? "#7f1414" : ""};
  span {
    display: ${props => props.required ? "inline-block" : "none"};
    color: ${props => props.required ? "#edbd2f" : "#fff"};
    padding-left: ${props => props.required ? "4px" : "4px"};
  }
`;

const Textarea = (props) => (
  <Wrapper block={props.block} hasError={props.hasError}>
    <LabelElement required={props.required}>{props.label}<span>*</span></LabelElement>
    <InputElement
      type={props.type} className={props.inputClassName} multiple={props.multiple}
      accept={props.accept} checked={props.checked} value={props.value} disabled={props.disabled} minLength={props.min}
      onChange={props.onChange} resize="none" onFocus={props.onFocus} placeholder={props.placeholder}
      hasError={props.hasError} maxLength={props.max}/>
  </Wrapper>
);

Textarea.defaultProps = {
  type: 'text'
};

Textarea.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func
};

export default Textarea;



// WEBPACK FOOTER //
// ./src/form/textarea.js